import _ from '@lodash';
import { Divider, withStyles, CircularProgress, Typography, LinearProgress } from '@material-ui/core';
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import clsx from 'clsx';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { Bar, Doughnut } from "react-chartjs-2";

const md = new MobileDetect(window.navigator.userAgent);


const styles = theme => ({
    defaultColor: {
        color: theme.palette.type === "dark" ? "#CCC" : "#666",
        textDecoration: "none !important",
        "&:hover": {
            textDecoration: "none !important",
            color: theme.palette.type === "dark" ? "#CCC" : "#666",
        },
        "&:focus": {
            textDecoration: "none !important",
            color: theme.palette.type === "dark" ? "#CCC" : "#666",
        }
    },
    box: {
        border: "1px solid " + theme.palette.divider
    },
    contrastBackground: {
        backgroundColor: theme.palette.background.paper,
    },
    bgColor: {
        height: 6,
        "& > div ": {
            backgroundColor: "#00D935",
        }
    }
});

class CaixaCard extends XAPPComponent {

    render() {
        const { data, openDialog, classes } = this.props;
        let AStatus = "Pendente";
        let ACorDestaque = "#F7C201";
        const formatter = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

        if (data.validado > 0 && data.recebido === 0) {
            ACorDestaque = "#00D935";
            AStatus = "Aprovado";
        }

        return (
            <React.Fragment>
                <div
                    className={clsx("flex flex-col md:flex-row w-full min-h-68 mb-8 cursor-pointer", classes.contrastBackground)}
                    key={"Caixa_" + data.recebimento}
                    style={{ borderLeft: `8px solid ${ACorDestaque}` }}
                    onClick={() => openDialog(data)}
                >
                    <div className={clsx(classes.box, "flex flex-row xs:flex-col-reverse xs:min-w-full sm:min-w-400 border-b-0 md:border-b-1 md:border-r-0")}>
                        <div className={clsx("flex flex-col w-full p-8 items-center")} >
                            <span className={clsx("flex flex-col w-full text-center")}>
                                {data.recebimento}
                            </span>
                            <span className={clsx("flex flex-col w-full text-center text-11")}>
                                {AStatus}
                            </span>
                        </div>
                        <div className={clsx("flex items-center p-12 md:border-r-1 sm:border-l-1 sm:min-w-128 justify-center", [0, 100].includes((data.validado / (data.recebido + data.validado)) * 100) && "xs:hidden")}>
                            <React.Fragment>
                                {AStatus === "Pendente" &&
                                    <div className={"relative inline-flex sm:hidden"}>
                                        <CircularProgress
                                            variant="static"
                                            value={(data.validado / (data.recebido + data.validado)) * 100}
                                            thickness={5}
                                            style={{ color: '#00D935', width: 52, height: 52 }}
                                        />
                                        <div
                                            style={{
                                                top: 0,
                                                left: 0,
                                                bottom: 0,
                                                right: 0,
                                                position: 'absolute',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <Typography variant="caption" component="div" color="text.secondary" className="text-11 font-bold">
                                                {`${Math.round((data.validado / (data.recebido + data.validado)) * 100)}%`}
                                            </Typography>
                                        </div>
                                    </div>
                                }
                                <div className="items-center flex xs:hidden">
                                    <div className="w-52 mr-6">
                                        <LinearProgress
                                            variant="determinate"
                                            value={(data.validado / (data.recebido + data.validado)) * 100}
                                            className={classes.bgColor}
                                            style={{ backgroundColor: '#F7C201' }}
                                        />
                                    </div>
                                    <Typography variant="caption" component="div" color="text.secondary" className="text-11 font-bold">
                                        {data.validado > 0 && (data.recebido + data.validado) > 0 ?
                                            `${Math.round((data.validado / (data.recebido + data.validado)) * 100)}%`
                                            :
                                            '0%'
                                        }
                                    </Typography>
                                </div>
                            </React.Fragment>
                        </div>
                    </div>
                    <div className={clsx(classes.box, "flex flex-row w-full sm:border-l-0")} >
                        <div className={clsx("flex flex-col w-full")}>
                            <div className={"flex flex-row w-full h-44 md:h-full md:max-h-80"}>
                                <div className={clsx("flex h-full items-center border-r-1", data.recebido < 1 && "xs:w-full")}>
                                    <div className={clsx("flex flex-col h-full w-180 justify-center gap-3", data.recebido < 1 && "xs:w-full")}>
                                        <span className={clsx("whitespace-no-wrap px-12 text-right", data.recebido < 1 && "xs:text-center")}>{formatter.format(data.valortotalcaixa)}</span>
                                    </div>
                                </div>
                                <div className={clsx("actionBar flex sm:min-w-256 items-center flex-row px-8 justify-start sm:border-0", data.recebido < 1 && "xs:hidden")}>
                                    {data.recebido > 0 &&
                                        <React.Fragment>
                                            <XAPPButton
                                                tooltip={{ "title": "Validação pendente", "placement": "top" }}
                                                type="Icon"
                                                className="p-6"
                                                iconProps="text-22"
                                                icon={"file_cifrao"}
                                                noHover
                                                badge={data.recebido}
                                                onClick={(ev) => { }}
                                            />
                                            <Divider className={clsx(classes.defaultColor, "w-px h-44 mx-8")} />
                                        </React.Fragment>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(CaixaCard);
